export default __webpack_public_path__ + "static/media/workout.2f773a86.jpg";